export const BEFORE_FETCH_ADVERT = 'BEFORE_FETCH_ADVERT';
export const FETCH_ADVERT = 'FETCH_ADVERT';
export const NETWORK_ERROR_FETCHING_ADVERT = 'NETWORK_ERROR_FETCHING_ADVERT';
export const BEFORE_SUMBITING_SURVEY = 'BEFORE_SUMBITING_SURVEY';
export const SUBMIT_SURVEY_ACTION = 'SUBMIT_SURVEY_ACTION';
export const ERROR_SUBMITTING_SURVEY = 'ERROR_SUBMITTING_SURVEY';